module.exports = __webpack_public_path__ + "static/img/agricultural_bank.d8033a73.png";